import { render, staticRenderFns } from "./RespectCard.vue?vue&type=template&id=6abeb443&"
import script from "./RespectCard.vue?vue&type=script&lang=ts&"
export * from "./RespectCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports